import SubHeader from '../helpers/SubHeader.tsx';
import { useState } from 'react';
import { NDialog, NLoading, NInfiniteScroll } from 'nayan';
import DrawingsNew from './DrawingsNew.tsx';
import { formatInfiniteQueryData } from '../../config/Config.ts';
import { useDrawingsData } from '../../services/DrawingsService.ts';
import DrawingsItem from './DrawingsItem.tsx';

const Drawings = () => {
  const [showModal, setShowModal] = useState(false);
  const { isLoading, data, fetchNextPage, hasNextPage, isFetching } = useDrawingsData();
  const drawings = formatInfiniteQueryData(data) || [];

  return (
    <div className="p-3">
      <SubHeader title="Drawings" showButton={true} clickButton={() => setShowModal(true)} />
      <NDialog title="Add Drawing" isOpen={showModal} onClose={() => setShowModal(false)}>
        <DrawingsNew closeModal={() => setShowModal(false)} />
      </NDialog>
      {isLoading && <NLoading />}
      <NInfiniteScroll
        next={() => !isFetching && fetchNextPage()}
        hasMore={!!hasNextPage}
        loader={<NLoading />}
        dataLength={drawings.length}
        scrollThreshold={0.99}>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3 pt-3 mb-3">
          {drawings.map((drawing: any) => (
            <DrawingsItem drawing={drawing} key={drawing.uuid} />
          ))}
        </div>
      </NInfiniteScroll>
      {!isLoading && !drawings.length && <div className="p-3 text-center">No drawings available!</div>}
    </div>
  );
};

export default Drawings;
